<style lang="less">
    @import "../../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list">
        <div class="table-list">
            <div class="table-list-title">
                <span class="myTitle">增加企业作者</span>
            </div>
            <div class="enterprise_authentication1_main">
                <ul class="main_group">
                    <li class="main_item">
                        <span class="item_title">证件类型：</span>
                        <div class="item_content">
                            <RadioGroup class="document_type" :value="documentTypeValue" disabled>
                                <Radio v-for="(item,index) in documentType" :key="index" disabled class="radio_item" :label="item.name" :value="item.value"><span  class="radio_item_name">{{ item.name }}</span></Radio>
                            </RadioGroup>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title top_title">营业执照：</span>
                        <div class="item_content">
                            <div class="upload_group">
                                <Upload
                                    disabled
                                        type="drag"
                                        name="poUpload"
                                        :data="requestData"
                                        :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                        :show-upload-list="false"
                                        :before-upload="upLoadBefore"
                                        :on-success="upLoadSuccess"
                                        :on-error="upLoadError"
                                        accept=".jpg,.jpeg,.png"
                                        style="display: inline-block;vertical-align: top;">

                                    <!--  没有图片时  -->
                                    <div v-if="licenseStatus == -1" class="upload_text">
                                        <div class="upload_text_add">+</div>
                                    </div>

                                    <!--  图片上传时  -->
                                    <div v-else-if="licenseStatus == 1" class="upload_ing">
                                        <div class="upload_ing_text">识别中...</div>
                                    </div>

                                    <!--  图片上传成功  -->
                                    <div v-else-if="licenseStatus == 0" class="upload_success">
                                        <img class="upload_success_img"
                                             :src="licensePhoto"
                                             alt='版权登记'>
                                    </div>
                                </Upload>
                            </div>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">社会统一信用代码 ：</span>
                        <div class="item_content">
                            <i-input v-model="licenseIdentityNo" disabled placeholder="请输入社会统一信用代码"></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">企业名称 ：</span>
                        <div class="item_content">
                            <i-input v-model="licenseName" disabled placeholder="请输入企业名称"></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">法人姓名：</span>
                        <div class="item_content">
                            <i-input v-model="legalName" disabled placeholder="请输入法人姓名"></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">营业期限：</span>
                        <div class="item_content">
                            <DatePicker class="item_date_list" style="width: 165px;" type="date" placeholder="开始时间" disabled
                                        :value="licenseAttachStartTime"
                                        format="yyyy-MM-dd"
                                        @on-change="startTimeChange"
                                        :options="disabledDate[0].start"></DatePicker>
                            <Select v-model="dateTypeValue" @on-change="dateTypeChange" class="item_date_list" disabled
                                    style="width: 175px;height: 48px;">
                                <Option v-for="(item,index) in dateType" :value="item.value" :key="index">{{item.label}}</Option>
                            </Select>
                            <DatePicker v-show="dateTypeValue!=0" class="item_date_list" style="width: 165px;" disabled
                                        type="date"
                                        :value="dateTypeValue == 0? licenseAttachEndTime='长期' : licenseAttachEndTime "
                                        placeholder="结束时间"
                                        format="yyyy-MM-dd"
                                        @on-change="endTimeChange"
                                        :options="disabledDate[1].end"></DatePicker>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">国家省市：</span>
                        <div class="item_content" style="color: #CBCBCB;">
                            <Select class="item_city_list" v-model="countrySelection" disabled>
                                <Option :value="countrySelection">{{countrySelection}}</Option>
                            </Select>
                            —
                            <Select class="item_city_list" v-model="provincesSelection" @on-change="provinceChange" disabled>
                                <Option v-for="(item,index) in cityData" :value="index" :key="index">{{index}}</Option>
                            </Select>
                            —
                            <Select class="item_city_list" v-model="citySelection" disabled>
                                <Option v-for="(item,index) in cityData[provincesSelection]" :value="item" :key="index">{{item}}
                                </Option>
                            </Select>

                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">详细地址：</span>
                        <div class="item_content">
                            <i-input v-model="licenseAddress" maxlength="200" disabled placeholder="请输入详细地址"></i-input>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
    import {_getProvinceAndCityList} from "@/api/authentication.js";
    import {_add,_obligeePowerUser} from "@/api/obligee.js";
    import Cookies from "js-cookie";

    export default {
        metaInfo: {
            title: '添加企业权利人|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '添加企业权利人,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "enterpriseAuthentication1",
        data() {
            return {
                documentType: [
                    {name: '企业营业执照', value: 'enterprise'},
                    {name: '个体工商户营业执照', value: 'individual'}
                ], //营业执照类型选择列表
                documentTypeValue: 'enterprise', //营业执照类型选中值
                requestData: {picType: 'business'}, //上传营业执照参数
                licenseStatus: -1, //营业执照上传状态：-1:未上传，1:上传中，0:上传成功
                licenseFileId: '', //营业执照文件id
                licensePhoto: '', //营业执照照片
                licenseAddress: '', //营业执照地址
                licenseName: '', //营业执照名称
                licenseIdentityNo: '', //统一社会信用代码
                licenseAttachStartTime: '', //证件开始日期
                licenseAttachEndTime: '', //证件结束日期
                legalName: '', //法人姓名
                cityData: [], //省份城市列表
                countrySelection: '中国', //选中国家
                provincesSelection: '北京', //选中省份
                citySelection: '北京', //选中城市
                disabledDate: [
                    {
                        start: {
                            disabledDate(date) {
                                return date && date.valueOf() > Date.now() - 172800;
                            }
                        }
                    },
                    {
                        end: {
                            disabledDate(date) {
                                return date && date.valueOf() < Date.now() - 8.64e7;
                            }
                        }
                    }
                ], //时间限制条件
                dateType: [
                    {value: 0, label: '无期限'},
                    {value: 1, label: '有期限（请选择日期）'},
                ], //时间下拉框选项
                dateTypeValue: 0, //当前时间选择值
                btnFlag: true //防止重复点击
            }
        },
        created() {
            this.getProvinceAndCityList();
            if (this.$route.query.id) {
                this._obligeePowerUser()
            }
        },
        methods: {

            // 权利人信息
             _obligeePowerUser() {
                let that = this
                _obligeePowerUser(that.$route.query.id).then(res => {
                    that.licensePhoto = res.result.attachment3Url
                    that.licenseStatus = 0
                    that.documentTypeValue = res.result.obligeeType == 'enterprise'?'企业营业执照':'个体工商户营业执照'
                    that.licenseIdentityNo = res.result.identityNumber
                    that.licenseName = res.result.name
                    that.legalName = res.result.legalName
                    that.licenseAttachStartTime = res.result.attachStartTime
                    that.licenseAttachEndTime = res.result.attachEndTime
                    that.countrySelection = res.result.country
                    that.provincesSelection = res.result.province
                    that.citySelection = res.result.city
                    that.licenseAddress = res.result.address
                    if (res.result.attachEndTime == '长期') {
                        that.dateTypeValue = 0
                    } else {
                        that.dateTypeValue = 1
                    }

                });
            },
            /****************证件类型改变事件**************/
            documentTypeChange(value) {
                if (value == '个体工商户营业执照') {
                    this.documentTypeValue = 'individual';
                } else {
                    this.documentTypeValue = 'enterprise';
                }
            },

            /****************上传营业执照钩子函数**************/
            upLoadBefore() {
                this.licenseStatus = 1;
            },

            upLoadSuccess(res) {
                if (res.code == 200 && res.result && res.result.reason == '成功') {
                    let result = res.result.result;
                    console.log(result);
                    this.licenseFileId = res.fileId;
                    this.licensePhoto = res.fileUrl;
                    this.licenseName = result.name;
                    this.licenseIdentityNo = result.reg_num;
                    this.legalName = result.person;
                    this.licenseAddress = result.address;

                    //由于后台无法精准给到开始时间，所以增加判断
                    if (result.regtime && result.regtime != '') {
                        this.licenseAttachStartTime = this.insertStr(this.insertStr(result.regtime, 4, '-'), 7, '-');
                    }

                    if (result.valid_period && result.valid_period != '' && result.valid_period != '长期') {
                        this.dateTypeValue = 1;
                        this.licenseAttachEndTime = this.insertStr(this.insertStr(result.valid_period, 4, '-'), 7, '-');
                    } else {
                        this.licenseAttachEndTime = result.valid_period;
                    }

                    this.licenseStatus = 0;

                } else {
                    this.upLoadError();
                }
            },

            upLoadError() {
                this.licenseFileId = '';
                this.licensePhoto = '';
                this.licenseName = '';
                this.licenseIdentityNo = '';
                this.licenseAttachStartTime = '';
                this.licenseAttachEndTime = '';
                this.licenseStatus = -1;
                toast('解析失败，请重试');
            },


            /****************获取省市列表接口数据**************/
            getProvinceAndCityList() {
                _getProvinceAndCityList().then(res => {
                    if (res) {
                        this.cityData = res;
                    }
                });

            },
            provinceChange(value) {
                this.citySelection = this.cityData[value][0];
            },


            /****************证件有效期开始时间**************/
            startTimeChange(value) {
                this.licenseAttachStartTime = value;
            },

            /****************证件有效期结束时间**************/
            endTimeChange(value) {
                this.licenseAttachEndTime = value;
            },

            /****************证件是否长期有效的改变事件**************/
            dateTypeChange(value) {
                this.licenseAttachEndTime = '';
            },


            /****************格式化时间方法**************/
            insertStr(soure, start, newStr) {
                return soure.slice(0, start) + newStr + soure.slice(start);
            },


            /****************点击下一步的校验**************/
            checkSubmit() {
                if (!this.btnFlag) {
                    return
                }

                if (this.licenseName != '' && this.licenseFileId != '' && this.licenseIdentityNo != '' && this.licenseName != '' && this.legalName != '' && this.licenseAttachStartTime != '' && this.licenseAttachEndTime != '' && this.countrySelection != '' && this.provincesSelection != '' && this.citySelection != '' && this.licenseAddress != '') {

                    this.btnFlag = false;
                    /****************判断是否登录***********/
                    if (Cookies.get("userInfo") && Cookies.get("userInfo") != '') {
                        var userInfo = JSON.parse(Cookies.get("userInfo"));
                    } else {
                        this.$router.push("/login");
                        return false;
                    }

                    let data = {
                        name: this.licenseName,
                        obligeeType: 'enterprise',
                        identityType: 4,
                        identityNumber: this.licenseIdentityNo,
                        address: this.licenseAddress,
                        country: this.countrySelection,
                        province: this.provincesSelection,
                        city: this.citySelection,
                        registerId: userInfo.id,
                        attachment3: this.licenseFileId,
                        attachment3Uuid: this.licenseFileId,
                        attachStartTime: this.licenseAttachStartTime,
                        attachEndTime: this.licenseAttachEndTime,
                        legalName: this.legalName,
                        authMethod: this.documentTypeValue
                    };
                    _add(data).then(res => {
                        if (res.code == 200) {
                            this.$router.push("/obligee");
                        } else {
                            toast(res.message);
                        }
                        this.btnFlag = true;
                    }, err => {
                        this.btnFlag = true;
                    })
                } else {
                    toast('请填写完整后再提交');
                }

            }


        }
    }
</script>

<style scoped lang="less">
    .center-table-list .table-list {
        height: 100%;
    }

    .enterprise_authentication1_main .main_group {
        min-height: 596px;
    }

    .main_group .main_item {
        display: flex;
        border-bottom: 1px solid #F3F3F3;
        padding: 20px 35px;
        color: #666;
        font-size: 14px;
    }

    .main_group .main_item:last-child {
        border-bottom: none;
    }

    .main_item .item_title {
        width: 130px;
        align-self: center;
    }

    .main_item .item_title.top_title {
        align-self: auto;
    }

    .main_item .item_content {
        flex: 1;
    }

    .document_type .radio_item_name {
        margin-left: 4px;
        font-size: 14px;
        color: #666666;
    }

    .document_type .radio_item {
        margin-right: 40px;
    }

    /deep/ .radio_item .ivu-radio-inner {
        width: 12px;
        height: 12px;
        border-radius: 0;
        border: 1px solid #B5B5B5;
    }

    .radio_item .ivu-radio-checked .ivu-radio-inner {
        border-color: #2196F3;
    }

    /deep/ .radio_item .ivu-radio-inner:after {
        width: 12px;
        height: 12px;
        left: -1px;
        top: -1px;
        border-radius: 0;
        background-color: #2196F3;
    }

    .upload_group .upload_desc {
        padding-top: 15px;
        color: #999999;
        font-size: 12px;
        line-height: 17px;
    }

    .upload_desc .demo_img {
        width: 325px;
        padding-top: 14px;
    }

    .upload_desc .demo_text {
        color: #666666;
        font-size: 12px;
        font-weight: bold;
        padding-top: 4px;
        display: flex;
        justify-content: space-around;
        list-style: none;
        width: 335px;
    }

    .demo_img img {
        display: block;
        width: 100%;
        height: 100px;
    }

    .upload_desc .upload_desc_group {
        list-style: none;
        padding-top: 5px;
    }

    /deep/ .ivu-input {
        width: 400px;
        height: 48px;
        /*border: 1px solid #CBCBCB;*/
        border-radius: 2px;
        box-shadow: none;
        font-size: 14px;
        line-height: 48px;
        color: #333;
        padding: 0 10px;
    }

    /deep/ .ivu-input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #999999;
    }

    .ivu-input::-moz-placeholder { /* Firefox 19+ */
        color: #999999;
    }

    .ivu-input:-ms-input-placeholder { /* IE 10+ */
        color: #999999;
    }

    .ivu-input:-moz-placeholder { /* Firefox 18- */
        color: #999999;
    }


    .myu_upload {
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        p {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            margin-top: 10px;
        }
    }


    /deep/ .ivu-upload {
        width: 130px;
        height: 160px;
        margin-right: 20px;
        display: flex;
    }

    /deep/ .ivu-upload-drag {
        border: 1px solid #CBCBCB;
    }

    .upload_text {
        align-self: center;
        margin: 0 auto;
        color: #999;
        font-size: 12px;
    }

    .upload_ing {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        display: flex;
    }

    .upload_ing .upload_ing_text {
        color: #fff;
        align-self: center;
        margin: 0 auto;
    }

    .upload_success {
        position: relative;
        width: 100%;
    }

    .upload_success .upload_success_img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }


    .upload_success .upload_success_btn {
        width: 82px;
        height: 26px;
        line-height: 26px;
        background: #2196F3;
        text-align: center;
        cursor: pointer;
        border-radius: 2px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 3;
        font-size: 14px;
        margin: -13px 0 0 -41px;
        transition: .3s ease-out;
    }

    .upload_success .upload_success_btn:hover {
        color: #fff;
        background-color: #cf7700;
        border-color: #cf7700;
    }

    .upload_text .upload_text_add {
        color: #A9A9A9;
        font-size: 40px;
        line-height: 1;
        margin-bottom: 9px;
    }


    /deep/ .item_date_list .ivu-input-suffix i {
        line-height: 48px;
    }

    .item_content .item_date_list {
        margin-right: 30px;
    }

    .item_content .item_date_list:last-child {
        margin-right: 0;
    }

    .item_content .item_city_list {
        width: 140px;
        height: 32px;
        /*margin-right: 35px;*/
    }

    .item_content .item_city_list:last-child {
        margin-right: 0;
    }

    /deep/ .item_city_list.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        text-align: center;
        color: #333333;
    }


    /deep/ .item_date_list.ivu-select-single .ivu-select-selection {
        height: 48px;
        border-radius: 2px;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection .ivu-select-placeholder {
        height: 48px;
        line-height: 48px;
        color: #999999;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 48px;
        line-height: 48px;
    }

    /deep/ .ivu-date-picker .ivu-input {
        width: 100%;
    }

    /deep/ .item_date_list .ivu-input-suffix i {
        line-height: 48px;
    }

    .item_content .item_date_list {
        margin-right: 30px;
    }

    .item_content .item_date_list:last-child {
        margin-right: 0;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection {
        height: 48px;
        border-radius: 2px;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection .ivu-select-placeholder {
        height: 48px;
        line-height: 48px;
        color: #999999;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 48px;
        line-height: 48px;
    }

    .submit_btn {
        width: 230px;
        height: 42px;
        line-height: 42px;
        background: #2196F3;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        display: inline-block;
        border-radius: 4px;
        cursor: pointer;
    }

</style>
